import React 			from 'react';
import PropTypes 	from 'prop-types';

import BLComponent from '../core/_BLComponent.jsx';

import FollowButton from '../common/_FollowButton.jsx';
import ProductCard 	from '../common/_ProductCard.jsx';
import { DateTime } 	from 'luxon'

export default class CollectionCard extends BLComponent 
{
	constructor(props) {
		super(props);
	}

	render() {
		const {data, classes = '', type, unfollow} = this.props;
		let teaserItems;
		let isNew = data.date.published && !data.showAsUpdated && Math.abs(blapp.time.fromMillis(data.date.published).diffNow('hours').toObject().hours) < 36;
		let showUpdated = data.date.published && data.showAsUpdated && Math.abs(blapp.time.fromMillis(data.date.published).diffNow('hours').toObject().hours) < 72;
		if(data.teaserItems) {
			teaserItems = data.teaserItems.map((item, key) => {
				const product = ProductCard.getDataFromBLMColletionItem(item)
				return (
					<div key={key} className="mdc-layout-grid__cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-3-desktop-l mdc-layout-grid__cell--span-2-phone">
						<ProductCard 
							classes="card--full-height trending-items__item product-card--truncate-title" 
							data={product} 
							wantedList={ProductCard.getWantedListEnableInfo( item.dmItemView, { location: blapp.srcmap.LOCATION.COLLECTION, typeSrcFrom: blapp.srcmap.SRCTYPE.COLLECTION, idSrcFrom: data.id } )}/>
					</div>
				);
			});
		}

		return (
			<article className={"collection-card " + classes + ' collection-card--' + type}>
				<div className="collection-card__internal">
					<a href={data.link} className="collection-card__image">
						<img src={data.image} className="collection-card__image-item"/>
					</a>
					<div className="collection-card__details">
						{type == 'extended' ? <span className="collection-card__small-title">{$T("COLLECTIONS")}</span> : null}
						{isNew ? <div className="collection-card__status collection-card__status--updated">{$T("NEW")}</div> : null}
						{showUpdated ? <div className="collection-card__status collection-card__status--updated">{$T("UPDATED")}</div> : null}
						{type == 'highlight' ? <div className="collection-card__status collection-card__status--discover">{$T("DISCOVER")}</div> : null}
						<h4 className="collection-card__header">
							<a href={data.link} className="link--inherit">
								{data.header}
							</a>
						</h4>
						<p className="collection-card__subheader">
							<a href={data.link} className="link--inherit">
								{data.subheader}
							</a>
						</p>
						<div className="collection-card__meta">
							<span className="collection-card__meta-item collection-card__meta-author">
								{data.author.name}
							</span>
							<span className="collection-card__meta-item collection-card__meta-date">{blapp.format.formatDateStructure(data.date.published)}</span>
						</div>
						{unfollow ? <FollowButton classes="collection-card__action" isFollowing={true} onClickFunc={() => unfollow(data.id)}/> : null}
					</div>
					{type == 'extended' && data.teaser ? 
						<div className="collection-card__teaser">
							{data.teaser}
						</div>
					: null}
					{type == 'extended' && data.teaserItems ? 
						<div className="collection-card__teaser-items l-full-width mdc-layout-grid l-pad-null">
							<div className="mdc-layout-grid__inner">
								{teaserItems}
							</div>
						</div>
					: null}
					{type == 'extended' ? 
						<div className="collection-card__discover">
							<a href={blapp.url2.getCollectionListUrl()}>{$T("BROWSE_MORE")}<i className="far fa-long-arrow-alt-right l-margin-left--sm"/></a>
						</div>
					: null}
				</div>
				{type == 'highlight' ? 
					<div className="collection-card__discover">
						<a href={blapp.url2.getCollectionListUrl()}>{$T("BROWSE_MORE")}<i className="far fa-long-arrow-alt-right l-margin-left--sm"/></a>
					</div>
				: null}
			</article>
		);
	}

	static getCollectionData( col ){
		return	{
					id:				col.idCollection
				,	header:			col.strTitle
				,	subheader:		col.strSubTitle
				,	teaser:			col.strTeaser
				,	image:			col.urlFileCover
				,	author:			{ 
										name: col.strAuthorOverride == '' ? col.dmUserAuthor.skUsername : col.strAuthorOverride 
									}
				,	date:			{
										published: 	col.tsPublished
									,	updated: 	col.tsModified
									}
				,	teaser:			col.strTeaser
				,	link:			blapp.url2.getCollectionUrl(col.idCollection)
				,	teaserItems:	col.arrPreviewItems
				,	showAsUpdated:  col.showAsUpdated
				}
	}
}

CollectionCard.propTypes = {
		classes: PropTypes.string
	,	data: PropTypes.shape({
				id: PropTypes.number.isRequired
			,	header: PropTypes.string.isRequired
			,	subheader: PropTypes.string.isRequired
			, image: PropTypes.string.isRequired
			, author: PropTypes.shape({
						name: PropTypes.string.isRequired
				})
			, date: PropTypes.shape({
						published: PropTypes.oneOfType([PropTypes.object, PropTypes.number]).isRequired
					,	updated: PropTypes.oneOfType([PropTypes.object, PropTypes.number]).isRequired
				})
			,	teaser: PropTypes.string
			, link: PropTypes.string.isRequired
		}).isRequired
	,	type: PropTypes.oneOf(['list', 'card', 'highlight', 'extended'])
	,	unfollow: PropTypes.func
}

var $T = BLComponent.createTextMap( 
	{
		"COLLECTIONS":
		{
			"en":	"Collections"
		,	"kr":	"콜렉션"
		,	"es":	"Colecciones"
		}
	,	"NEW":
		{
			"en":	"New"
		,	"kr":	"신규"
		,	"es":	"Nueva"
		}
	,	"UPDATED":
		{
			"en":	"Updated"
		,	"kr":	"업데이트"
		,	"es":	"Actualizada"
		}
	,	"DISCOVER":
		{
			"en":	"Discover"
		,	"kr":	"Discover"
		,	"es":	"Descubre"
		}
	,	"BROWSE_MORE":
		{
			"en":	"Browse more collections"
		,	"kr":	"콜렉션 더보기"
		,	"es":	"Ver más colecciones"
		}
	}
);